__turbopack_context__.v({
  "back": "zuM3DG_back",
  "closeButton": "zuM3DG_closeButton",
  "closeButtonIcon": "zuM3DG_closeButtonIcon",
  "content": "zuM3DG_content",
  "iconBack": "zuM3DG_iconBack",
  "list": "zuM3DG_list",
  "popup": "zuM3DG_popup",
  "popupContainer": "zuM3DG_popupContainer",
  "title": "zuM3DG_title",
  "word": "zuM3DG_word",
});
